export default __webpack_public_path__ + "static/media/iconTopRight.48f02ffa.png";